import { useWindowResize } from "./useWindowResize";

export const useResponsive = () => {
  const { width } = useWindowResize();

  return {
    isMobile: width <= 900,
  };
};
